var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskGroup20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 75,
    height: 75,
    transform: "translate(298 5787)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20",
    "data-name": "Mask Group 20",
    transform: "translate(-298 -5787)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subscription_1_",
    "data-name": "subscription (1)",
    transform: "translate(304.998 5787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M30.567,11.45h8.739L36,14.766a2.2,2.2,0,0,0,3.11,3.1l7.048-7.06a2.2,2.2,0,0,0-.05-3.155l-7-7.01A2.2,2.2,0,1,0,36,3.75l3.3,3.306H30.472C7.244,7.055-7.5,32.336,4.147,52.656a2.2,2.2,0,1,0,3.813-2.185c-10.024-17.488,2.807-39.12,22.607-39.02Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M56.858,22.343a2.2,2.2,0,1,0-3.812,2.186c9.948,17.355-2.608,39.02-22.543,39.02H21.7l3.31-3.315a2.2,2.2,0,1,0-3.11-3.1L14.85,64.19a2.2,2.2,0,0,0,.053,3.158l7,7.007a2.2,2.2,0,0,0,3.11-3.1l-3.3-3.306H30.53c23.241,0,37.973-25.284,26.328-45.6Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M28.305,30.908h8.789a2.2,2.2,0,0,0,0-4.395H32.7v-2.2a2.2,2.2,0,0,0-4.395,0v2.2a6.592,6.592,0,0,0,0,13.184H32.7a2.2,2.2,0,1,1,0,4.4H23.911a2.2,2.2,0,0,0,0,4.395h4.4v2.2a2.2,2.2,0,0,0,4.395,0v-2.2a6.592,6.592,0,0,0,0-13.184H28.305a2.2,2.2,0,1,1,0-4.395Zm0,0",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup20);
export default __webpack_public_path__ + "static/media/Mask Group 20.8c59ecb2cf2e52ede774ec8ba0e5444b.svg";
export { ForwardRef as ReactComponent };